import Axios from 'axios'
import { CART_SET } from '../mutation-types'

// initial state
const state = {
  id: '',
  taxRate: 0,
  taxAmount: 0,
  totalAmount: 0,
  subTotalAmount: 0,
  currency: '',
  items: [],
  gtmProducts: [],
  isSubscription: false,
  isUpgrade: false,
  couponCode: '',
  firstName: '',
  lastName: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postcode: '',
  countryCode: '',
  company: '',
  fetchingCart: false
}

const actions = {
  fetch ({ commit }) {
    commit('setFetchingCartState', true)
    Axios.get('/cart/info')
      .then((response) => commit(CART_SET, response.data))
      .catch(error => console.log(error))
      .finally(() => {
        commit('setFetchingCartState', false)
      })
  },
  updateAddress ({ commit }, { useraddress }) {
    return Axios.post('/cart/update', {
      userAddress: useraddress
    })
      .then(response => {
        commit(CART_SET, response.data)
        return response.data
      })
      .catch(error => console.log(error))
  },
  addCoupon ({ commit }, { couponCode }) {
    return Axios.post('/cart/update', {
      couponCode: couponCode
    })
      .then(response => {
        if (response.data.error) {
          this.dispatch('globalstate/error', response.data)
          // return the error to the component to display it under the input text.
          return response.data
        } else {
          commit(CART_SET, response.data)
        }
      })
      .catch(error => console.log(error))
  },
  removeCoupon ({ commit }) {
    Axios.post('/cart/update', {
      action: 'removecoupon'
    })
      .then(response => commit(CART_SET, response.data))
      .catch(error => console.log(error))
  },
  removeCart ({ commit }) {
    commit('removeCart')
  }
}
const mutations = {
  [CART_SET] (state, newState) {
    if (newState !== undefined && newState !== null) {
      state.id = newState.id
      state.countryCode = newState.country_code ? newState.country_code : ''
      state.taxRate = newState.tax_rate
      state.taxAmount = newState.tax_amount
      state.totalAmount = newState.total_amount
      state.subTotalAmount = newState.sub_total_amount
      state.currency = newState.currency
      state.items = newState.items
      state.couponCode = newState.coupon_code
      state.firstName = newState.first_name ? newState.first_name : ''
      state.lastName = newState.last_name ? newState.last_name : ''
      state.address1 = newState.address1 ? newState.address1 : ''
      state.address2 = newState.address2 ? newState.address2 : ''
      state.city = newState.city ? newState.city : ''
      state.state = newState.state ? newState.state : ''
      state.postcode = newState.zip ? newState.zip : ''
      state.company = newState.company ? newState.company : ''
      // this only happen with an empty cart...
      if (newState.items !== undefined && newState.items.length > 0) {
        state.isSubscription = newState.items[0].product_type.subscription || false
        state.isUpgrade = newState.items[0].product_type.isUpgrade || false
      }
    }

    if (state.items && state.items.length > 0) {
      state.gtmProducts.length = 0
      for (var i = 0; i < state.items.length; i++) {
        state.gtmProducts.push(
          {
            'name': state.items[i].product_type.name,
            'id': state.items[i].product_type.sku,
            'price': state.items[i].price,
            'category': 'Software/DJ products',
            'quantity': state.items[i].quantity
          }
        )
      }
    }
  },

  setFetchingCartState (state, newState) {
    state.fetchingCart = newState
  },

  removeCart (state, newState) {
    state.id = ''
    state.countryCode = ''
    state.taxRate = 0
    state.taxAmount = 0
    state.totalAmount = 0
    state.subTotalAmount = 0
    state.currency = ''
    state.items = []
    state.gtmProducts = []
    state.isSubscription = false
    state.isUpgrade = false
    state.couponCode = ''
    state.firstName = ''
    state.lastName = ''
    state.address1 = ''
    state.address2 = ''
    state.city = ''
    state.state = ''
    state.postcode = ''
    state.company = ''
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./vue/checkout/store/modules/cart.js